import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import Modal from 'meinian-package/src/component/modal'
import Checkbox from 'meinian-package/src/baseComponent/checkbox'
import Button from 'meinian-package/src/baseComponent/button'
import Icon from 'meinian-package/src/component/icon'
import request from 'meinian-package/src/utils/request'
import classNames from 'classnames'
import { useLockFn } from 'ahooks'
import styles from './index.module.less'

export default (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<ViewSettingModal {...props} visible container={div} />, div)
  })
}

const defaultValue = {
  imageTextType: 'waterfall', // -- 图文模式: waterfall-瀑布流, proportionally-等比例
  imageType: 'proportionally', // -- 纯图模式: waterfall-瀑布流, proportionally-等比例
  markInfo: 1, // -- 审核信息: 1-勾选, 0-未勾选
  originalInfo: 1, // -- 原文信息: 1-勾选, 0-未勾选
  socialInfo: 1 // -- 社交信息: 1-勾选, 0-未勾选
}

export const getViewConfig = async () => {
  const result = await request.get('/zhikuan/mn/propagate/get-view-type')
  return {
    ...result,
    markInfo: !!result.markInfo,
    originalInfo: !!result.originalInfo,
    socialInfo: !!result.socialInfo
  }
}

const ViewSettingModal = ({ visible, onCancel }) => {
  const [value, setValue] = useState(defaultValue)
  const [_visible, set_Visible] = useState(visible)

  useEffect(() => {
    request.get('/zhikuan/mn/propagate/get-view-type').then(result => {
      setValue(result || defaultValue)
    })
  }, [])

  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }

  const onSave = useLockFn(async () => {
    await request.post('/zhikuan/mn/propagate/save-view-type', { ...value })
  })

  return <Modal
    style={{ width: '416px', height: '539px', borderRadius: '6px' }}
    visible={_visible}
    onCancel={_cancel}
    footer={<div>
      <Button
        type="primary"
        style={{ width: '80px', borderRadius: '6px' }}
        onClick={async () => {
          await onSave()
          location.reload()
        }}
      >保存</Button>
    </div>}
  >
    <div className={styles.viewSettingModal}>
      <div className="viewSettingModalHeader">视图设置</div>
      <div className="viewSettingTitle">款式卡片视图设置</div>
      <div className="viewSettingContent">
        <div className="viewSettingContentItem" style={{ marginTop: '16px' }}>
          <div className="viewSettingContentItemLabel">图文模式</div>
          <div
            className={classNames('viewSettingContentItemValue', { active: value.imageTextType === 'waterfall' })}
            onClick={() => setValue(pre => ({
              ...pre,
              imageTextType: 'waterfall'
            }))}
          ><Icon type="m-pubuliu" className="viewSettingContentItemValueIcon" />瀑布流</div>
          <div
            className={classNames('viewSettingContentItemValue', { active: value.imageTextType === 'proportionally' })}
            onClick={() => setValue(pre => ({
              ...pre,
              imageTextType: 'proportionally'
            }))}
          ><Icon type="m-duotumoshi" className="viewSettingContentItemValueIcon" />等比例</div>
        </div>
        <div className="viewSettingContentItem" style={{ marginTop: '12px' }}>
          <div className="viewSettingContentItemLabel">多图模式</div>
          <div
            className={classNames('viewSettingContentItemValue', { active: true })}
          ><Icon type="m-duotumoshi" className="viewSettingContentItemValueIcon" />等比例</div>
        </div>
        <div className="viewSettingContentItem" style={{ marginTop: '12px' }}>
          <div className="viewSettingContentItemLabel">纯图模式</div>
          <div
            className={classNames('viewSettingContentItemValue', { active: value.imageType === 'waterfall' })}
            onClick={() => setValue(pre => ({
              ...pre,
              imageType: 'waterfall'
            }))}
          ><Icon type="m-pubuliu" className="viewSettingContentItemValueIcon" />瀑布流</div>
          <div
            className={classNames('viewSettingContentItemValue', { active: value.imageType === 'proportionally' })}
            onClick={() => setValue(pre => ({
              ...pre,
              imageType: 'proportionally'
            }))}
          ><Icon type="m-duotumoshi" className="viewSettingContentItemValueIcon" />等比例</div>
        </div>
      </div>
      <div className="viewSettingTitle">款式卡片信息展示设置</div>
      <div className="informationSetting">
        <div className="informationSettingItem">
          <div className="informationSettingItemCheckbox">
            <Checkbox
              checked={value.originalInfo}
              onChange={(e) => {
                setValue(pre => ({
                  ...pre,
                  originalInfo: e.target.checked ? 1 : 0
                }))
              }}
            />
          </div>
          <div className="informationSettingItemInfo">
            <div className="informationSettingItemInfoTitle">展示原文信息</div>
            <div className="informationSettingItemInfoComment">如：点赞、收藏、评论、销量等</div>
          </div>
        </div>
        <div className="informationSettingItem">
          <div className="informationSettingItemCheckbox">
            <Checkbox
              checked={value.socialInfo}
              onChange={(e) => {
                setValue(pre => ({
                  ...pre,
                  socialInfo: e.target.checked ? 1 : 0
                }))
              }}
            />
          </div>
          <div className="informationSettingItemInfo">
            <div className="informationSettingItemInfoTitle">展示社交信息</div>
            <div className="informationSettingItemInfoComment">如：批注</div>
          </div>
        </div>
        <div className="informationSettingItem">
          <div className="informationSettingItemCheckbox">
            <Checkbox
              checked={value.markInfo}
              onChange={(e) => {
                setValue(pre => ({
                  ...pre,
                  markInfo: e.target.checked ? 1 : 0
                }))
              }}
            />
          </div>
          <div className="informationSettingItemInfo">
            <div className="informationSettingItemInfoTitle">展示审核信息</div>
            <div className="informationSettingItemInfoComment">如：审核状态和审核操作按钮</div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
}
